import React from 'react'
import { connect } from 'react-redux'

import { createStyles, Theme } from '@material-ui/core'
import { WithStyles, withStyles } from '@material-ui/styles'

import { AppState } from '../store/AppState'
import { Site, SitesState } from '../store/Site'
import { SiteContextData } from './contexts/SiteContext'
import { withUiContext, UiContextData } from './contexts/UiContext'
import { User } from 'oidc-client'
import { Group } from '../store/Group'
import {
  withMySitesContext,
  MySitesContextData,
} from './contexts/MySitesContext'
import LayoutProductionPanel from './productionPanel/layout/'

const styles = (theme: Theme) =>
  createStyles({
    root: {
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    },
    tile: {
      padding: theme.spacing(0.5),
      overflow: 'hidden',
      display: 'grid',
    },
    noStretchTile: {
      display: 'flex',
      padding: theme.spacing(0.5),
    },
  })

interface PropsFromState {
  readonly user?: User
  readonly groups: Group[]
}

type AllProps = PropsFromState &
  WithStyles<typeof styles> &
  UiContextData &
  SiteContextData &
  MySitesContextData

interface State extends SiteContextData {
  readonly sites: SitesState
  readonly mySites: Site[]
}

export class Home extends React.Component<AllProps, State> {
  public componentDidMount() {
    this.props.setPageTitle!('Production Panel')
  }

  public render() {
    return (
      <div className={this.props.classes.root}>
        {this.renderMySitesAndMap()}
      </div>
    )
  }

  private renderMySitesAndMap() {
    return <LayoutProductionPanel />
  }
}

const mapStateToProps = ({ groups, oidc }: AppState): PropsFromState => {
  return {
    user: oidc.user,
    groups: groups.groups,
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(withUiContext(withMySitesContext(Home)))
)
